export const FUNNEL_QA_ACTIONS = {
  DUPLICATE: "DUPLICATE",
  DELETE: "DELETE",
  COPY: "COPY"
};
export const QUESTION_TYPE = {
  ICONS: "ICONS",
  TEXTONLY: "TEXTONLY",
  FREE_TEXT_FIELD: "FREE_TEXT_FIELD",
  SLIDER: "SLIDER"
};

export const FUNNEL_TYPE_FILTER = {
  ALL: "ALL",
  LEAD: "LEAD",
  EMPLOYEE: "EMPLOYEE"
};

export const FUNNEL_BUILD_STATUS = {
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  FAIL: "FAIL"
};

export const INTEGRATION_TYPE = {
  GOOGLESHEET: "GOOGLE-SHEET",
  ZAPIER: "ZAPIER",
  SLACK: "SLACK",
  CONTACT_CLOUD: "CONTACT_CLOUD",
  EMAIL: "EMAIL",
  LEADPOOL: "LEADPOOL"
};

export const DATE_FORMAT = "YYYY-MM-DD";

export const DATE_REVERSE_FORMAT = "DD-MM-YYYY";

export const DATE_DISPLAY_FORMAT = "DD.MM.YYYY";

export const DATE_PICKER_DISPLAY_FORMAT = "dd.MM.yyyy";

export const DATE_TIME_FORMAT = `${DATE_DISPLAY_FORMAT} HH:mm`;

export const DATE_TIME_COMPLETE_FORMAT = "YYYY-MM-DD HH:mm:ss";

export const DATE_TIME_WITH_MONTH_FORMAT = "DD-MMM-YYYY HH:mm";

export const DISPLAY_FUNNEL = {
  ARCHIVED_ONES: "ARCHIVED_ONES",
  NON_ARCHIVED_ONES: "NON_ARCHIVED_ONES"
};

export const S3_FOLDER_ENUM = {
  QA: "QA",
  ASSET: "ASSET",
  GALLERY: "GALLERY"
};

export const LEAD_LOGS_STATUS_TYPE = {
  SUCCESS: "SUCCESS",
  FAIL: "FAIL",
  RETRY: "RETRY"
};

export const FUNNEL_PAGES = {
  FUNNEL_FORM: "FUNNEL_FORM",
  LANDING_PAGE: "LANDING_PAGE",
  FUNNEL_FILTERS: "FUNNEL_FILTERS",
  INTEGRATION_FORM: "INTEGRATION_FORM",
  FUNNEL_INSIGHT: "FUNNEL_INSIGHT",
  COCKPIT_FORM: "COCKPIT_FORM",
  FACEBOOK_FORM: "FACEBOOK_FORM",
  AD_COPY: "AD_COPY",
  AD_DUPLICATOR: "AD_DUPLICATOR",
  LS_OVERVIEW: "LS_OVERVIEW",
  CAMPAIGNS_REVIEW: "CAMPAIGNS_REVIEW",
  PERFORMANCE: "PERFORMANCE"
};

export const TEMPLATES = {
  FUNNEL_TEMPLATE: "funnel_templates",
  GLOBAL_THANK_YOU_TEMPLATE: "global_thank_you_template",
  PRIVACY_CONSENT: "privacy_consent"
};

export const FORM_SOURCE_TYPE = {
  FB: "FB",
  CP: "CP",
  CP_FB: "CP_FB"
};

export const LEAD_SOURCE = {
  CP: "CP",
  FB_CP: "FB_CP",
  FB_AD: "FB_AD",
  HOMEPAGE: "homepage",
  UNCATEGORISED: "uncategorised"
};

export const MODAL_TYPE = {
  VIEW: "VIEW",
  CREATE: "CREATE",
  SEARCH: "SEARCH"
};

export const FOOTER_FOREGROUND = {
  BLACK: "#000000",
  WHITE: "#ffffff",
  SHADOWED: "shadowed"
};

export const ACTIVITY_TYPES = {
  CALL: "CALL",
  APPOINTMENT: "APPOINTMENT",
  SMS: "SMS",
  EMAIL: "EMAIL",
  RESET: "RESET",
  SYNC_MANUALLY: "SYNC_MANUALLY",
  PARTIAL_SYNC_MANUALLY: "PARTIAL_SYNC_MANUALLY",
  DIGITAL_VERIFICATION: "DIGITAL_VERIFICATION",
  LEAD_RESUBMISSION: "LEAD_RESUBMISSION",
  AI_LEADSERVICE_HANDOFF: "AI_LEADSERVICE_HANDOFF",
  AI_LEADSERVICE_MANUAL_TAKEOVER: "AI_LEADSERVICE_MANUAL_TAKEOVER",
  MANUAL_LEAD_SERVICE_REMOVAL: "MANUAL_LEAD_SERVICE_REMOVAL",
  AUTOPILOT: "AUTOPILOT"
};

export const ACTIVITY_RESULT_TYPES = {
  NUMBER_WRONG: "NUMBER_WRONG",
  NAME_WRONG: "NAME_WRONG",
  COMPLETED: "COMPLETED",
  CALL: "CALL",
  CALL_NOT_INITIATED: "CALL_NOT_INITIATED",
  QUALIFIED: "QUALIFIED",
  NOT_SUITABLE: "NOT_SUITABLE",
  NOT_REACHED: "NOT_REACHED",
  RESET_SUCCESS: "RESET_SUCCESS",
  SYNCED_MANUALLY: "SYNCED_MANUALLY",
  CONTACT_LATER: "CONTACT_LATER",
  APPOINTMENT_CALL: "APPOINTMENT_CALL",
  APPOINTMENT_CANCELLED: "APPOINTMENT_CANCELLED",
  APPOINTMENT_CONFIRMED: "APPOINTMENT_CONFIRMED",
  APPOINTMENT_POSTPONED: "APPOINTMENT_POSTPONED",
  APPOINTMENT_NOT_REACHED: "APPOINTMENT_NOT_REACHED",
  APPOINTMENT_NOT_HANDLED: "APPOINTMENT_NOT_HANDLED",
  APPOINTMENT_UPDATED: "APPOINTMENT_UPDATED",
  LEAD_RESUBMITTED: "LEAD_RESUBMITTED",
  LEAD_SERVICE_REMOVED: "LEAD_SERVICE_REMOVED",
  AUTOPILOT_APPOINTMENT: "AUTOPILOT_APPOINTMENT",
  AUTOPILOT_CLOSED: "AUTOPILOT_CLOSED",
  AUTOPILOT_ENDED: "AUTOPILOT_ENDED",
  AUTOPILOT_REACTIVATION: "AUTOPILOT_REACTIVATION"
};

// A&M Autopilot lead routing (ticket 1219547818089406): state of a lead from
// its field `autopilot`. Mirror of viewStateOf in the backend's
// services/autopilot-routing.rules.js; the lead list and the agent panel need
// it before any Autopilot call. Change both together, the cases are pinned in
// strings.autopilot.test.js and in the backend's autopilot-routing.rules.test.js.
export const AUTOPILOT_VIEW_STATE = {
  WITH_AUTOPILOT: "WITH_AUTOPILOT",
  IN_LEADSERVICE: "IN_LEADSERVICE",
  RELEASED: "RELEASED",
  CLOSED: "CLOSED",
  ENDED: "ENDED"
};

export const autopilotViewState = (lead) => {
  const autopilot = lead?.autopilot;
  if (!autopilot?.active) return null;
  if (autopilot.ccReleasedAt) return AUTOPILOT_VIEW_STATE.RELEASED;
  if (autopilot.closedAt) return AUTOPILOT_VIEW_STATE.CLOSED;
  if (autopilot.endedAt) return AUTOPILOT_VIEW_STATE.ENDED;
  return autopilot.releasedAt
    ? AUTOPILOT_VIEW_STATE.IN_LEADSERVICE
    : AUTOPILOT_VIEW_STATE.WITH_AUTOPILOT;
};

// The Autopilot's own Zapier integration (am_autopilot linkFunnels). Same URL
// rule as AUTOPILOT_INGEST in the backend's services/autopilot-funnel.service.js;
// unlike the backend it keeps inactive rows, the integration page shows them
// as "Nicht aktiv".
export const isAutopilotIntegration = (integration) =>
  integration?.type === INTEGRATION_TYPE.ZAPIER &&
  /\/api\/webhooks\/autopilot-ingest\/?$/.test(
    String(integration?.sourceData?.id || "")
  );

export const LEAD_INTERACTION_STATUS = {
  INITIATED: "INITIATED",
  NOT_INITIATED: "NOT_INITIATED",
  HANDLED: "HANDLED"
};

export const FB_FORM_MODE = {
  EDITABLE: "EDITABLE",
  READONLY: "READONLY",
  ADD_NEW: "ADD_NEW"
};

export const SELECT_TAB = {
  SEARCH: "SEARCH",
  CUSTOM: "CUSTOM"
};

export const USER_ROLES = {
  SUPER_ADMIN: "SUPER_ADMIN",
  ADMIN: "ADMIN",
  MARKETING_MANAGER: "MARKETING_MANAGER",
  AGENT: "AGENT"
};

export const USER_STATUS = {
  ACTIVE: "ACTIVE",
  IN_ACTIVE: "IN-ACTIVE"
};

export const TONALITY_TYPES = {
  SERIOUS: "Seriös",
  CASUAL: "Lässig",
  HUMOROUS: "Humorvoll",
  INSPIRING: "Inspirierend",
  ROMANTIC: "Romantisch",
  FACTUAL: "Sachlich",
  NOSTALGIC: "Nostalgisch",
  PROVOCATIVE: "Provokativ",
  LUXURIOUS: "Luxuriös",
  EDUCATIONAL: "Pädagogisch"
};

export const EMOJI_SELCECT_LABELS = {
  Ja: "Ja",
  Nein: "Nein"
};

export const SEND_DATA = {
  NEVER: "NEVER",
  IMMEDIATELY: "IMMEDIATELY",
  AFTER_CONFIRMATION: "AFTER_CONFIRMATION"
};

export const LEAD_AGENT_TIMESTAMP_UPDATE_DELAY = 1 * 1000 * 60;

export const MULTI_FACTOR_TYPES = {
  AUTHENTICATOR: "AUTHENTICATOR",
  EMAIL: "EMAIL"
};

export const PHONE_NUMBER_RADIO = {
  STANDARD: "STANDARD",
  LIGHT: "LIGHT",
  VERIFY: "VERIFY"
};

// Platform tells the backend which service should use the selected pixel.
export const CONVERSION_API_PLATFORM = {
  FACEBOOK: "facebook",
  TIKTOK: "tiktok"
};

export const FB_CONVERSION_API_OPTS = {
  WAREHOUSES: {
    name: "A&M Data Warehouses Pixel",
    _id: "2236084886702651",
    platform: CONVERSION_API_PLATFORM.FACEBOOK
  },
  GMBHS: {
    name: "A&M Unternehmerberatung GmbHs Pixel",
    _id: "1048497165333604",
    platform: CONVERSION_API_PLATFORM.FACEBOOK
  },
  PIXEL_2_WAREHOUSE: {
    name: "A&M Pixel 2 (Warehouse)",
    _id: "3141170769443692",
    platform: CONVERSION_API_PLATFORM.FACEBOOK
  }
};

export const TIKTOK_CONVERSION_API_OPTS = {
  // Global TikTok pixel used by all funnels in Phase 1.
  GLOBAL: {
    name: "A&M Global TikTok Pixel",
    _id: "D66PBGJC77U42FK00EF0",
    platform: CONVERSION_API_PLATFORM.TIKTOK
  }
};

export const ICON_TYPE = {
  ALREADY_INITIATED: "ALREADY_INITIATED",
  ALREADY_QUALIFIED: "ALREADY_QUALIFIED",
  NOT_AVAILABLE_NOW: "NOT_AVAILABLE_NOW",
  ALREADY_ASSIGNED: "ALREADY_ASSIGNED",
  TARGET_BLANK: "TARGET_BLANK",
  ARCHIVED: "ARCHIVED",
  NO_LEADS: "NO_LEADS",
  CONTACT_LATER: "CONTACT_LATER",
  APPOINTMENT_TAKEN: "APPOINTMENT_TAKEN",
  APPOINTMENT_NOT_TAKEN: "APPOINTMENT_NOT_TAKEN",
  APPOINTMENT_CONFIRMED: "APPOINTMENT_CONFIRMED",
  APPOINTMENT_CANCELLED: "APPOINTMENT_CANCELLED",
  NO_CONFIRMATION: "NO_CONFIRMATION",
  NOT_AVAILABLE_2H: "NOT_AVAILABLE_2H",
  AI_LEADSERVICE_SENT: "AI_LEADSERVICE_SENT"
};

export const SETTINGS = {
  PROFILE: "PROFILE",
  SECURITY: "SECURITY",
  CHANGE_PASSWORD: "CHANGE_PASSWORD"
};

export const CUSTOMER_ROUTES = {
  OVERVIEW: "OVERVIEW",
  FUNNELS: "FUNNELS",
  LEADS: "LEADS",
  PERFORMANCE_REPORT: "PERFORMANCE_REPORT",
  WEBSITE: "WEBSITE",
  INVOICES: "INVOICES"
};

export const NESTED_SIDENAV = {
  FUNNEL: "FUNNEL",
  TEMPLATE: "TEMPLATE",
  EVALUATION: "EVALUATION",
  ADS_EVALUATION: "ADS-EVALUATION",
  MISSING_INFO: "MISSING-INFO",
  SITE_SETTINGS: "SITE-SETTINGS",
  SETTING: "SETTING",
  CUSTOMER: "CUSTOMER",
  TOOLS: "TOOLS",
  LEADSERVICE_PANEL: "LEADSERVICE_PANEL",
  WEBSITE: "WEBSITE",
  SPLIT_TESTS: "SPLIT_TESTS"
};

export const EVALUATION_TYPE = {
  OVERVIEW: "OVERVIEW",
  INSIGHTS: "INSIGHTS",
  OPTIMIZATION: "OPTIMIZATION",
  ZIP_CHECK: "ZIP_CHECK"
  // EXPORT_QUERIES: "EXPORT_QUERIES"
};

export const LEADSERVICE_PANEL_TABS = {
  LEADSERVICE: "LEADSERVICE",
  APPOINTMENTS_PANEL: "APPOINTMENTS_PANEL"
};

export const CREATIVE_DASHBOARD_TABS = {
  OVERVIEW: "OVERVIEW",
  SUGGESTION_GALLERY: "SUGGESTION_GALLERY",
  FUNNEL_OVERVIEW: "FUNNEL_OVERVIEW"
};

export const MISSING_INFO_TYPE = {
  LEAD_INFO: "LEAD",
  CATEGORY_INFO: "CATEGORY",
  CUSTOMER_INFO: "CUSTOMER",
  HUBSPOT_INFO: "HUBSPOT",
  AD_ACCOUNT: "AD-ACCOUNT",
  UTM_PARAMETER: "UTM-PARAMETER"
};

export const LEAD_AD_ASSOCIATION_STATUS = {
  IGNORED: "IGNORED",
  HANDLED: "HANDLED"
};

export const SITE_SETTINGS_TYPE = {
  FACEBOOK_ACCOUNTS: "FACEBOOK-ACCOUNTS",
  FORM_DEFAULTS: "FORM-DEFAULTS",
  COUNTRIES: "COUNTRIES"
};

export const SPLIT_TEST_TABS = {
  LEAD: "LEAD",
  EMPLOYEE: "EMPLOYEE"
};

export const SPLIT_TEST_STATUS = {
  PROPOSED: "PROPOSED",
  RUNNING: "RUNNING",
  WON: "WON",
  LOST: "LOST",
  NO_DIFFERENCE: "NO_DIFFERENCE",
  CANCELLED: "CANCELLED",
  REVERTED: "REVERTED"
};

export const TOOLS_TYPE = {
  DUPLICATOR: "DUPLICATOR",
  WEBSITE_CREATION_LOGS: "WEBSITE_CREATION_LOGS"
  // INSIGHTS: "INSIGHTS"
};

export const INTEGRATION_NAMES = {
  ZAPIER: "ZAPIER",
  SLACK: "SLACK",
  LEAD_SERVICE: "LEAD_SERVICE",
  EMAIL: "EMAIL",
  CONTACT_CLOUD: "CONTACT_CLOUD",
  LEADPOOL: "LEADPOOL",
  APPOINTMENT_LINK: "APPOINTMENT_LINK",
  ADVERTISING_ACCOUNT_LINK: "ADVERTISING_ACCOUNT_LINK",
  RECLAIM_MODE: "RECLAIM_MODE"
};

export const COUNTRY_GERMANY = "germany";

export const SEARCH_LEAD_BY = {
  PHONE: "PHONE",
  EMAIL: "EMAIL",
  AUTO: "AUTO",
  FUNNEL: "FUNNEL",
  APPOINTMENT: "APPOINTMENT",
  MANUAL_TAKEOVER: "MANUAL_TAKEOVER"
};

export const EURO_CURRENCY_SYMBOL = "€";

export const LEAD_SERVICE_PLUS_EDIT_MODES = {
  FOR_COMPANY: "forCompany",
  FOR_PRODUCT: "forProduct",
  FOR_PRICE: "forPrice",
  FOR_FIXED_PRICE: "forFixedPrice",
  FOR_UNIT: "forUnit",
  FOR_BUDGET_QUERY: "forBudgetQuery",
  FOR_PRICES_PER_AREA: "forPricesPerArea",
  FOR_BUDGET_QUERY_BOUNDS: "forBudgetQueryBounds",
  FOR_INDIVIDUAL_NOTE: "forIndividualNote"
};

export const PRICE_TYPE = {
  DYNAMIC: "DYNAMIC",
  FIXED: "FIXED",
  AREA_QUERY: "AREA-QUERY"
};

export const THUMBNAIL_TYPE = {
  BACKGROUND: "background", // 1920 x 1080 -> desktop background (for funnel app)
  MOBILE_BACKGROUND: "mobile_background", // 480 x 800 -> mobile background (for funnel app)
  GALLERY_FORM_ASSET: "gallery_form_asset", // 230 x unknown -> gallery form asset
  COMPANY_LOGO: "company_logo", // 580 x unknown -> header logo (for funnel app)
  PARTNER_LOGO: "partner_logo", // 380 x unknown -> footer logo (for funnel app)
  ANSWER_OPTION_ICON: "answer_option_icon", // 214 x unknown -> answer option image
  GALLERY_MODAL_ASSET: "gallery_modal_asset", // 177 x unknown -> gallery modal image
  WEBSITE_SERVICE_ASSET: "website_service_asset" // 400 x 300 -> customer website services images
};

export const FUNNEL_DESIGNS = {
  CLASSIC: "CLASSIC",
  MODERN: "MODERN"
};

// Partner logo of the classic funnel footer (Asana 1213410886347834), same
// values as cockpit-shared. A funnel without a stored mode is MANUAL.
export const PARTNER_LOGO_MODE = {
  AUTO_LIGHT: "AUTO_LIGHT",
  AUTO_DARK: "AUTO_DARK",
  MANUAL: "MANUAL"
};
export const PARTNER_LOGO_SCALE = { MIN: 50, MAX: 100 };

export const LEAD_AGENT_TIMESTAMP_SESSION_EXPIRY = 30 * 60 * 1000;

export const TESTED_LINK_STATUS = {
  NEUTRAL: "NEUTRAL",
  POSITIVE: "POSITIVE",
  NEGATIVE: "NEGATIVE"
};

export const HUBSPOT_PROJECT_ID_LINK =
  "https://app.hubspot.com/contacts/4583994/record/2-7095914";

export const SCRIPT_ROUTE = {
  LS: "leadservice",
  LS_PLUS: "leadservice-plus",
  AP: "appointment-confirmation",
  RECLAIM_LEADS: "reclaim-leads",
  FOLLOWUP: "offer-followup"
};

export const SCRIPT_WORKSPACE_PATH = {
  LS: "leadServiceScript",
  LS_PLUS: "leadServicePlusScript",
  AP: "appointmentConfirmationScript",
  RECLAIM_LEADS: "filteredLeadScript",
  FOLLOWUP: "offerFollowupScript"
};

export const SCRIPT_LOCAL_FILE_NAME = {
  LS: "default.pdf",
  LS_PLUS: "leadservice_plus.pdf",
  AP: "appointment_confirmation.pdf",
  RECLAIM_LEADS: "filtered_lead.pdf",
  FOLLOWUP: "offer_followup.pdf"
};

export const DISPLAY_SUGGESTIONS = {
  ARCHIVED_ONES: "ARCHIVED_ONES",
  WINNING_ONES: "WINNING_ONES",
  NORMAL_ONES: "NORMAL_ONES"
};

export const LEAD_VIEW = {
  COMPLETED: "COMPLETED",
  PARTIAL: "PARTIAL"
};

export const CUSTOMER_TYPE = {
  COCKPIT: "COCKPIT",
  HUBSPOT: "HUBSPOT"
};

export const NOT_SUITABLE_STAGE = "not_suitable";

export const OFFER_SENT_STAGE = "offer_sent";

export const CREATIVE_ASSET_INSIGHT_TYPE = {
  BODY_ASSET: "body_asset",
  TITLE_ASSET: "title_asset",
  DESCRIPTION_ASSET: "description_asset"
};

export const FORM_IMAGE_PLACEMENT = {
  BEFORE: "BEFORE",
  AFTER: "AFTER"
};

export const FUNNEL_PERFORMANCE_DURATION_FILTER = {
  WEEK: "BT_L7D",
  FORTNIGHT: "BT_L14D",
  MONTH: "BT_L30D",
  BT_LAST_NINETY_DAYS: "BT_L90D",
  CUSTOM_RANGE_UPTO_L90D: "CR_L90D"
};

export const SYSTEM_HEALTH_ALERT_ACTION = {
  FACEBOOK_AD_LEAD_FAILED: "FACEBOOK_AD_LEAD_FAILED",
  CC_DEAL_UPDATE_FAILED: "CC_DEAL_UPDATE_FAILED",
  SPLIT_TEST_ROLLOUT_FAILED: "SPLIT_TEST_ROLLOUT_FAILED",
  SPLIT_TEST_PROPOSAL_FAILED: "SPLIT_TEST_PROPOSAL_FAILED"
};

export const SYSTEM_HEALTH_ALERT_ISSUE = {
  ERROR_READING: "ERROR_READING",
  UNKNOWN: "UNKNOWN",
  INVALID_ACCESS_TOKEN: "INVALID_ACCESS_TOKEN",
  API_LIMIT_REACHED: "API_LIMIT_REACHED"
};

export const LANDING_PAGE_TEMPLATES = {
  FUNNEL_LANDING_PAGE_TEMP_ONE: "FunnelLandingPageTpl1",
  FUNNEL_LANDING_PAGE_TEMP_TWO: "FunnelLandingPageTpl2"
};

export const QUESTION_POSITION = {
  next: "next",
  last: "last",
  multi: "multi"
};

export const DISBALE_LS_ACTIONS = {
  SYNC_NOW_AND_DISABLE: "SYNC_NOW_AND_DISABLE",
  DISABLE_NOW_AND_SYNC_LATER: "DISABLE_NOW_AND_SYNC_LATER"
};

export const CAMPAIGN_TASK = {
  CREATED: "CREATED",
  IGNORED: "IGNORED"
};

export const APPOINTMENT_EMAIL_TEMPLATES = {
  CONFIRM_EMAIL: "CONFIRM_EMAIL",
  CANCEL_EMAIL: "CANCEL_EMAIL",
  POSTPONE_EMAIL: "POSTPONE_EMAIL",
  LEAD_NOT_REACHED: "LEAD_NOT_REACHED"
};

export const APPOINTMENT_STATUS = {
  CONFIRMED: "CONFIRMED",
  CANCELLED: "CANCELLED",
  NOT_TAKEN: "NOT_TAKEN",
  NOT_HANDLED: "NOT_HANDLED",
  BOOKED: "BOOKED",
  POSTPONED: "POSTPONED"
};

export const DNS_RECORD_TYPES = {
  ACTIVE: "ACTIVE",
  NON_ACTIVE: "NON_ACTIVE",
  NOT_FOUND: "NOT_FOUND"
};

export const SORT_FILTER_TYPES = {
  PERFORMANCE_REPORT: "PERFORMANCE_REPORT",
  EVALUATION_OVERVIEW: "EVALUATION_OVERVIEW"
};

export const BLOCKED_LEAD_TASK_TYPE = {
  DAILY: "DAILY",
  WEEKLY: "WEEKLY"
};

export const APPOINTMENT_TYPE = {
  ONSITE_AT_LEAD_ADDRESS: "ONSITE_AT_LEAD_ADDRESS",
  ONSITE_AT_COMPANY_ADDRESS: "ONSITE_AT_COMPANY_ADDRESS",
  PHONE_APPOINTMENT: "PHONE_APPOINTMENT"
};

export const CUSTOMER_SITE_CREATION_STATUS = {
  RECEIVED: "RECEIVED",
  PROCESSING: "PROCESSING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED"
};

export const CUSTOMER_SITE_CREATION_ERROR_LOGS = {
  AI_CONTENT_GENERATION_FAILED: "AI_CONTENT_GENERATION_FAILED",
  CUSTOMER_CREATION_FAILED: "CUSTOMER_CREATION_FAILED"
};

export const LS_TYPE_FILTERS = {
  ALL: "all",
  LS: "ls",
  LS_PLUS: "ls-plus",
  LS_PLUS_WITH_APPOINTMENT: "ls-plus-with-appointment"
};

export const LS_TRACKING_RESULT_HASH = {
  OPEN: "open",
  SUITABLE: "suitable",
  NAME_WRONG: "nameWrong",
  NUMBER_WRONG: "numberWrong",
  NOT_REACHED: "notReached",
  NOT_SUITABLE: "notSuitable",
  NON_CLASSIFIED: "nonClassified",
  NOT_SUITABLE_DUE_TO_CALL_RESULT: "notSuitableDueToCallResult",
  NOT_SUITABLE_DUE_TO_ACCESSIBILITY: "notSuitableDueToAccessibility"
};

export const NON_CLASSIFIED = "NON_CLASSIFIED";

export const WEBSITE_TABS = {
  EDITOR: "EDITOR",
  FUNNELS: "FUNNELS",
  ANALYTICS: "ANALYTICS",
  LOCAL_SEO: "LOCAL_SEO"
};

export const WEBSITE_CLICKS = {
  NAVBAR_PHONE: "Navbar Phone", // non-CTA
  NAVBAR_SECOND_PHONE: "Navbar Second Phone", // non-CTA
  FOOTER_EMAIL: "Footer Email", // non-CTA
  FOOTER_PHONE: "Footer Phone", // non-CTA
  FOOTER_CONTACT: "Footer Contact", // CTA
  FOOTER_CONTACT_OPTIONAL: "Footer Contact (Optional)" // CTA
};

export const YOUTUBE_EMBED_URL_REGEX =
  /^https:\/\/www\.youtube\.com\/embed\/[a-zA-Z0-9_-]{11}$/;

export const YOUTUBE_VIDEO_ID_REGEX = /^[a-zA-Z0-9_-]{11}$/;

export const WISTIA_EMBED_URL_REGEX =
  /^https:\/\/fast\.wistia\.net\/embed\/iframe\/[a-z0-9]{10}$/;

export const WISTIA_MEDIA_ID_REGEX = /^[a-z0-9]{10}$/;

export const WEBSITE_FONTS = {
  DEFAULT: "default",
  CLASH_DISPLAY_SEMI_BOLD: "clash-display-semi-bold",
  SATOSHI_BOLD: "satoshi-bold",
  SATOSHI_MEDIUM: "satoshi-medium",
  SATOSHI_REGULAR: "satoshi-regular"
};

export const ACCESS_CONFIG = {
  ONLY_SUPER_ADMIN: [USER_ROLES.SUPER_ADMIN],
  // ADMIN and above roles
  ADMIN_TIER: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN],
  // MARKETING_MANAGER and all above roles
  MARKETING_MANAGER_TIER: [
    USER_ROLES.SUPER_ADMIN,
    USER_ROLES.ADMIN,
    USER_ROLES.MARKETING_MANAGER
  ],
  ALL_ROLES: Object.values(USER_ROLES),
  ONLY_AGENT: [USER_ROLES.AGENT]
};

export const LOCAL_SEO_FIELDS_NAME = {
  cities: "cities",
  keywords: "keywords"
};

export const SUB_PAGE_STATUS = {
  NEW: "NEW",
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED"
};

export const SUB_PAGE_SYSTEM_TAG_IDENTIFIER = {
  "Sub Hero": "sub_page_hero",
  "Sub Benefit": "benefit_section_image"
};

export const SEO_PAGE_IMAGE_SECTIONS = ["Sub Hero", "Sub Benefit"];

export const DEFAULT_WEB_TEMP = "TEMPLATE_1";

export const WEBSITE_BASE_TAB_ROUTE = "/";

export const DEFAULT_WEBSITE_LANGUAGE = "de";

export const WEBSITE_LANGUAGE_OPTIONS = [
  { value: "de", label: "Deutsch" },
  { value: "en", label: "English" }
];

export const CUSTOMER_WEBSITE_ROUTE = "website";

export const ACTIVITY_KINDS = {
  CALL_ATTEMPT: "CALL_ATTEMPT",
  APPOINTMENT_CALL_ATTEMPT: "APPOINTMENT_CALL_ATTEMPT",
  SYSTEM_ACTIVITY: "SYSTEM_ACTIVITY"
};

export const CALL_NOT_INITIATED_REASONS = {
  LEAD_UNAVAILABLE: "LEAD_UNAVAILABLE"
};

export const APPOINTMENT_CALL_RESULT_TYPES = [
  ACTIVITY_RESULT_TYPES.APPOINTMENT_CALL,
  ACTIVITY_RESULT_TYPES.APPOINTMENT_CANCELLED,
  ACTIVITY_RESULT_TYPES.APPOINTMENT_CONFIRMED,
  ACTIVITY_RESULT_TYPES.APPOINTMENT_POSTPONED,
  ACTIVITY_RESULT_TYPES.APPOINTMENT_NOT_REACHED,
  ACTIVITY_RESULT_TYPES.APPOINTMENT_NOT_HANDLED
];

export const AI_INTERVIEW_STATUS = {
  ACTIVE: "ACTIVE",
  COMPLETED: "COMPLETED",
  SKIPPED: "SKIPPED"
};

export const OFFER_FOLLOWUP_OUTCOMES = {
  SUITABLE: "SUITABLE",
  NOT_SUITABLE: "NOT_SUITABLE",
  CALLBACK_REQUIRED: "CALLBACK_REQUIRED",
  NOT_REACHED: "NOT_REACHED"
};

export const OFFER_FOLLOWUP_SEARCH_OPTIONS = [
  SEARCH_LEAD_BY.PHONE,
  SEARCH_LEAD_BY.EMAIL
];

export const OFFER_FOLLOWUP_NEXT_ATTEMPT_FIELDS = [
  "nextAttemptAfter",
  "nextScheduledAt",
  "nextAttemptAt"
];

export const TIME_DATE_FORMAT = "YYYY-MM-DDTHH:mm";

export const ALL_DOTS_REG_PATTERN = /\./g;

export const PRICE_VARIANTS_FOR_LEAD_AGENT = "priceVariantsForLeadAgent";

export const LEAD_AGENT_PRICE_VARIANTS = {
  STANDARD: "priceVariantsForLeadAgent",
  FIXED_PRICE: "fixedPriceVariantsForLeadAgent"
};

export const COUNTRY_MAP_TAG_NAME = "country_map";
